/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LockAgentsRequest
 */
export interface LockAgentsRequest {
    /**
     * CM group ids of the agents whose lock state should be changed.
     * @type {Array<number>}
     * @memberof LockAgentsRequest
     */
    cmGroupIds: Array<number>;
    /**
     * True to apply an agency lock, false to release it.
     * @type {boolean}
     * @memberof LockAgentsRequest
     */
    lock?: boolean;
}

/**
 * Check if a given object implements the LockAgentsRequest interface.
 */
export function instanceOfLockAgentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cmGroupIds" in value;

    return isInstance;
}

export function LockAgentsRequestFromJSON(json: any): LockAgentsRequest {
    return LockAgentsRequestFromJSONTyped(json, false);
}

export function LockAgentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LockAgentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cmGroupIds': json['cmGroupIds'],
        'lock': !exists(json, 'lock') ? undefined : json['lock'],
    };
}

export function LockAgentsRequestToJSON(value?: LockAgentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cmGroupIds': value.cmGroupIds,
        'lock': value.lock,
    };
}

